<template>
  <div class="huihua">
    <div class="huihuabg">
      <appHeader activeIndex="huihua" ></appHeader>
      <div class="huihuaContent">
        <!-- 介绍 -->
        <div class="huihuaInfo">
          <div class="huihuaInfo1">
            <img class="huihuaInfo1Img1" src="../../assets/img/Product/huihua.png"  alt />
            <br>
            <img class="huihuaInfo1Img2"  src="../../assets/img/products/huihua/huihuaQRcode.png" alt />
            <div>扫描二维码下载</div>     
          </div>
          <div class="huihuaInfo2">
            <img src="../../assets/img/products/huihua/huihuaFont.png" alt />
             <el-divider></el-divider>
             <h2>应用介绍</h2>
             <p>迷你绘画世界：打开神奇的迷你世界，在这里欢畅的绘画吧！</p>
             <p>【绘画素材百变多样】在迷你绘画世界，选择你喜欢的类型进行绘画吧！包含六大绘画类型：水果、动物、生肖、蔬菜、挑战、卡通！</p>
             <p>【上百张图片等你画】每个类型下面，都有非常多的绘画图片哦！滑动手机，找到那张小可爱来绘画吧！</p>
             <p>【轻松绘画 随意上色】在绘画界面中，你可以根据示意图来绘画，也可以随意涂抹，给图片使用你喜欢的颜色、像素，不喜欢也可以擦掉重新画！</p>
             <p>【虚线提示 提升乐趣】如果你想要跟图示画的一样好，那么你可以选择提示来打开虚线图，根据虚线图来临摹吧！相信一定有另一番乐趣哦！</p>
             <p>【保存图片 画册欣赏】画上一副美画，一定要保存起来，去画册中慢慢欣赏吧，保留你美好天真的回忆，给你一个愉快的心情！</p>
             <p>【愉快配乐 放松心情】迷你绘画世界搭配了轻松的音乐，让你在绘画的同时，感受音乐带来的欢快！如果不喜欢，也可以选择关掉它，用心去绘画吧！
迷你绘画世界，带你畅游在想象的欢快绘画海洋！</p>
            
          </div>
          <div style="clear: both;"></div> 
        </div>
        <!-- 第二部分内容 -->
        <el-divider></el-divider>
        <div class="huihuaCarousel">
          <div class="iconLeft" @click="left"><el-button icon="el-icon-arrow-left" circle></el-button></div>
          <div class="iconRight" @click="right"><el-button icon="el-icon-arrow-right" circle></el-button></div>
          <div class="huihuaWrap">
            <!-- <div class="huihuaMainImg" :style="{ left: nowLeft + '%' }"> -->
              <img class="huihuaCarouselImg"   src="../../assets/img/products/huihua/carousel.png" :style="{ left: nowLeft + '%' }" alt />
            <!-- </div> -->
          </div>
          
        </div>
      </div>
    </div>
    <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  mounted() {},
  methods: {
    
      left() {
        
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +20
      },

      right() {
        if(this.nowLeft <= -140){
          return;
        }
        this.nowLeft = this.nowLeft -20
      }
  }
};
</script>
<style>
@import "../../assets/css/products/huihua.css";
</style>
